var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics-table"},[_c('statistics-table-header'),_c('div',{staticClass:"statistics-table__blur_top"}),_vm._t("default"),_c('div',{staticClass:"statistics-table__blur_bottom"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }